/* eslint-disable */
/// This file is auto generated - do not edit manually
export const TagTitle = 'Website.PersonalOffer.OffersLoginNudge.TagTitle';
export const Title = 'Website.PersonalOffer.OffersLoginNudge.Title';
export const SubTitle = 'Website.PersonalOffer.OffersLoginNudge.SubTitle';
export const LoginButtonLabel = 'Website.PersonalOffer.OffersLoginNudge.LoginButtonLabel';
export const LoadingTitle = 'Website.PersonalOffer.OffersLoginNudge.LoadingTitle';
